import { render, staticRenderFns } from "./Expedition.vue?vue&type=template&id=53389694&scoped=true&"
import script from "./Expedition.vue?vue&type=script&lang=js&"
export * from "./Expedition.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRetur.scss?vue&type=style&index=0&id=53389694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53389694",
  null
  
)

export default component.exports